import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-blog-details-right-sidebar',
  templateUrl: './breadcrumb-blog-details-right-sidebar.component.html',
  styleUrls: ['./breadcrumb-blog-details-right-sidebar.component.css']
})
export class BreadcrumbBlogDetailsRightSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
